import React, {createContext} from 'react';

export const LocalizationContext = createContext({
    nameSpace: ''
});
